import { z } from "zod";
import { engineSchema } from "../capture.js";
/**
 * The operator panel's wire, shared parts.
 *
 * These schemas are the promise the API will keep to the panel. The screens are
 * built against them first, with sample data parsed through the same schemas,
 * so the day the API exists it has one thing to match and the screens have
 * nothing to change (plans/admin-panel.md).
 *
 * Money is integer micro-dollars and rates are basis points, never floats
 * (AGENTS.md §7): DataForSEO's `runs.cost_usd` is a fraction of a cent, and a
 * float sum of ten thousand of them drifts.
 */
/** A calendar day, `YYYY-MM-DD`, in the capture timezone. */
export const adminDaySchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/u);
/**
 * Every engine a run can carry, not only the two captured today: runs from the
 * browser-worker days (Perplexity) are real history and stay readable.
 */
export const adminEngineSchema = engineSchema;
/** `pending` is a run with no outcome yet, which the database holds as null. */
export const adminRunStateSchema = z.enum([
    "success",
    "no_answer",
    "challenge",
    "site_error",
    "selector_drift",
    "login_required",
    "signup_required",
    "pending",
]);
export const adminRangeDaysSchema = z.union([
    z.literal(7),
    z.literal(14),
    z.literal(30),
    z.literal(90),
]);
export const adminRangeSchema = z.object({ days: adminRangeDaysSchema });
export const adminHealthSchema = z.enum(["healthy", "degraded", "down", "unknown"]);
/**
 * A value the database may not hold yet.
 *
 * `not_recorded` names what would record it (`needs`), so the screen can say
 * *Not recorded yet, needs users.last_login_at* rather than show a zero. The
 * union cannot be rendered without handling the second arm, which is the same
 * guarantee `MetricValue` gives the customer app (AGENTS.md §1).
 */
export function adminRecordedSchema(inner) {
    return z.discriminatedUnion("kind", [
        z.object({ kind: z.literal("value"), value: inner }),
        z.object({
            kind: z.literal("not_recorded"),
            reason: z.string(),
            needs: z.string(),
        }),
    ]);
}
export const adminPageQuerySchema = z.object({
    limit: z.number().int().positive().max(100),
    offset: z.number().int().nonnegative(),
});
export const adminMicrosSchema = z.number().int();
export const adminCountSchema = z.number().int().nonnegative();
//# sourceMappingURL=common.js.map